/* AC Browse tabs: the tab switcher and the sideways rail for sections/ac-browse-tabs.liquid. Loaded with defer.
   Arrow keys and Home and End move between the tabs. With "Infinite loop" on, the tiles are cloned before and after
   the originals, and the rail jumps back by one set when it settles outside the middle set. */

if (!customElements.get('ac-browse-tabs')) {
  customElements.define('ac-browse-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.alls = Array.from(this.querySelectorAll('[data-abt-all]'));
      this.prev = this.querySelector('[data-abt-prev]');
      this.next = this.querySelector('[data-abt-next]');
      this.loop = this.hasAttribute('data-loop');
      this.update = this.update.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.tabs.forEach((t, i) => {
        t.addEventListener('click', () => this.select(i));
        t.addEventListener('keydown', (e) => {
          const n = this.tabs.length;
          let j = null;
          if (e.key === 'ArrowRight') j = (i + 1) % n;
          if (e.key === 'ArrowLeft') j = (i - 1 + n) % n;
          if (e.key === 'Home') j = 0;
          if (e.key === 'End') j = n - 1;
          if (j !== null) { e.preventDefault(); this.select(j, true); }
        });
      });
      if (this.prev) this.prev.addEventListener('click', () => this.scroll(-1));
      if (this.next) this.next.addEventListener('click', () => this.scroll(1));
      this.panels.forEach((p) => {
        const r = p.querySelector('.abt__rail');
        if (!r) return;
        r.addEventListener('scroll', this.onScroll, { passive: true });
        if ('onscrollend' in window) r.addEventListener('scrollend', () => this.normalize(r));
      });
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => { this.normalize(this.rail()); this.update(); });
        this.ro.observe(this);
      }
      this.onBlock = (e) => {
        const t = e.target && e.target.closest ? e.target.closest('[role="tab"]') : null;
        if (t && this.contains(t)) this.select(this.tabs.indexOf(t));
      };
      document.addEventListener('shopify:block:select', this.onBlock);
      const start = this.tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true');
      this.select(start < 0 ? 0 : start);
    }
    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      document.removeEventListener('shopify:block:select', this.onBlock);
    }
    rail() {
      const p = this.panels[this.i];
      return p ? p.querySelector('.abt__rail') : null;
    }
    setupLoop(r) {
      if (!this.loop || !r || r.dataset.abtLoop) return;
      const orig = Array.from(r.children);
      if (!orig.length || r.scrollWidth <= r.clientWidth + 2) return;
      const vis = orig.filter((el) => el.offsetWidth > 0);
      if (!vis.length) return;
      const gap = parseFloat(getComputedStyle(r).columnGap) || 0;
      const last = vis[vis.length - 1];
      const setW0 = last.offsetLeft + last.offsetWidth + gap - vis[0].offsetLeft;
      const copies = Math.max(1, Math.ceil((2 * Math.max(window.innerWidth, r.clientWidth)) / setW0));
      const mk = () => {
        const f = document.createDocumentFragment();
        orig.forEach((el) => {
          const c = el.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          c.setAttribute('data-abt-clone', '');
          c.inert = true;
          c.querySelectorAll('a,button').forEach((x) => x.setAttribute('tabindex', '-1'));
          f.appendChild(c);
        });
        return f;
      };
      for (let k = 0; k < copies; k++) { r.insertBefore(mk(), r.firstChild); r.appendChild(mk()); }
      const idx = orig.indexOf(vis[0]);
      r._abtOrig = vis[0];
      r._abtNext = r.children[(copies + 1) * orig.length + idx];
      r._abtCopies = copies;
      r.dataset.abtLoop = '1';
    }
    setW(r) {
      return r && r._abtOrig && r._abtNext ? r._abtNext.offsetLeft - r._abtOrig.offsetLeft : 0;
    }
    home(r) {
      if (!r) return;
      const w = this.setW(r);
      r.scrollLeft = w ? w * r._abtCopies : 0;
    }
    normalize(r) {
      const w = this.setW(r);
      if (!w) return;
      const mid = w * r._abtCopies;
      let x = r.scrollLeft;
      if (x < mid - 1) x += w * Math.ceil((mid - x - 1) / w);
      else if (x >= mid + w - 1) x -= w * Math.floor((x - mid + 1) / w);
      if (Math.abs(x - r.scrollLeft) > 1) r.scrollLeft = x;
    }
    onScroll(e) {
      const r = e.currentTarget;
      if (!('onscrollend' in window)) { clearTimeout(r._abtT); r._abtT = setTimeout(() => this.normalize(r), 140); }
      this.update();
    }
    select(i, focus) {
      if (i < 0 || i >= this.tabs.length) return;
      this.i = i;
      this.tabs.forEach((t, j) => { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); t.tabIndex = j === i ? 0 : -1; });
      this.panels.forEach((p, j) => { p.hidden = j !== i; });
      this.alls.forEach((a) => { a.hidden = Number(a.dataset.abtAll) !== i; });
      const r = this.rail();
      if (r) { this.setupLoop(r); this.home(r); }
      if (focus) this.tabs[i].focus();
      this.update();
    }
    scroll(dir) {
      const r = this.rail();
      if (!r) return;
      this.normalize(r);
      r.scrollBy({ left: dir * Math.max(r.clientWidth * 0.8, 200), behavior: 'smooth' });
    }
    update() {
      const r = this.rail();
      if (!r) { this.setAttribute('data-noscroll', ''); return; }
      const max = r.scrollWidth - r.clientWidth - 2;
      this.toggleAttribute('data-noscroll', max <= 0);
      const looping = !!this.setW(r);
      if (this.prev) this.prev.disabled = !looping && r.scrollLeft <= 2;
      if (this.next) this.next.disabled = !looping && r.scrollLeft >= max;
    }
  });
}
